// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-in-up-enter-active[data-v-0263f4c4],.fade-in-up-leave-active[data-v-0263f4c4]{transition:.5s}.fade-in-up-enter[data-v-0263f4c4],.fade-in-up-leave-to[data-v-0263f4c4]{opacity:0;transform:translateY(5px)}.submit-button[data-v-0263f4c4]{margin-top:30px;text-align:center}.btn[data-v-0263f4c4]{min-width:140px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
